import {
  createApp,
  h
} from 'vue'

import 'vant/lib/index.css'
import ajax from './utils/request'
import './assets/css/animate.min.css'
import './assets/css/common.css'
import './assets/css/style.css'
import {
  isLogin
} from './utils/util'

import App from './App.vue'
import router from './router'
import store from './store'
import vantConfig from 'vant'
import {
  showDialog,
  showConfirmDialog,
  showNotify,
  showToast,
  showLoadingToast,
  closeToast,
  closeDialog
} from 'vant';

import head from "./components/head.vue";
import Tabbar from "./components/tabBar/index.js"
// dsq add 图片展开缩放效果
import ImgBox from "./components/ImgBox.vue"
import Seamless from 'vue3-seamless-scroll';

const app = createApp({
  mounted() {},
  render: () => h(App)
})
app.component('myhead', head)
app.component('ImgBox', ImgBox)

app.mixin({
  data() {
    return {
      showDialog,
      showConfirmDialog,
      showNotify,
      showLoadingToast,
      closeToast,
      showToast,
      closeDialog,
      isLogin,
      ajax: ajax,
      imgError: 'this.src="' + require('@/assets/img/empty.png') + '"',
      userError: 'this.src="' + require('@/assets/img/me2.png') + '"',
      page: 1,
      count: 0,
      keyword: ''
    }
  },
  mounted() {
    const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    let originPortrait = window.matchMedia("(orientation: portrait)").matches
    let originalHeight = document.documentElement.clientHeight || document.body.clientHeight;
    let inputList = document.getElementsByTagName("input");
    if (isiOS) {
      for (let input of inputList) {
        input.onfocus = () => {
          this.$store.state.nokey = false
        }
      }
    } else {
      // window.addEventListener("orientationchange",()=>{
      //   this.showToast("旋转了") //不起效
      // })
      window.addEventListener('resize', () => {
        // 它只检测竖屏，检测不到切横屏
        let portrait = window.matchMedia("(orientation: portrait)").matches;
        if (originPortrait != portrait) {
          originPortrait = portrait
          originalHeight = document.documentElement.clientHeight || document.body.clientHeight;
          return this.$store.state.nokey = true;
        }
        const resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
        if (resizeHeight - 0 < originalHeight - 80) { //682 738  可能是头部栏高度有变化吧，要减去80
          this.$store.state.nokey = false
        } else {
          this.$store.state.nokey = true
        }
      });
    }
    for (let input of inputList) {
      input.onfocusout = () => {
        this.$store.state.nokey = true
      }
      input.onblur = () => {
        this.$store.state.nokey = true
      }
    }

  }
})
app.use(Seamless)
app.use(vantConfig)
app.use(Tabbar)
app.use(router).use(store).mount("#app");